import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  teasElement;

  connect() {
    this.teasElement = document.querySelector("div#teas");
  }

  shuffle = e => {
    Array.from(this.teasElement.children)
      .sort(() => Math.random() - 0.5)
      .forEach(child => this.teasElement.appendChild(child));
  }
}
